import React from "react";
import { ChevronEndIcon, Flex, Text } from "@fluentui/react-northstar";
import { FolderPersonRegular } from "@fluentui/react-icons";
import styled from "styled-components";

/**
 * BreadcrumbFolders component renders a breadcrumb navigation using Fluent UI and styled-components.
 *
 * @typedef {Object} BreadcrumbItem
 * @property {string} key - The unique key for the breadcrumb item.
 * @property {string} name - The display name for the breadcrumb item.
 *
 * @param {Object} props - The component props.
 * @param {BreadcrumbItem[]} props.breadcrumb - An array of breadcrumb items.
 *
 * @returns {JSX.Element} The rendered breadcrumb navigation.
 */
const BreadcrumbFolders = ({
    breadcrumb = [],
    icon = <FolderPersonRegular fontSize={24} />,
    onClickBreadcrumbItem = () => null,
}) => {
    return (
        <Flex gap="gap.medium">
            {/* affichage icone dossier */}
            <Flex vAlign="center" hAlign="center">
                {icon}
            </Flex>
            {breadcrumb.map((item, i) => {
                const last_item = i === breadcrumb.length - 1;
                const first_item = i === 0;
                return (
                    <Flex
                        gap="gap.medium"
                        vAlign="center"
                        key={item.key}
                        onClick={() =>
                            !last_item &&
                            onClickBreadcrumbItem(first_item ? null : item.key)
                        }
                    >
                        <Flex gap="gap.small" vAlign="center">
                            <NavItem
                                className={last_item ? "lastItem" : ""}
                                key={item.key}
                            >
                                {item.name}
                            </NavItem>
                        </Flex>
                        {!last_item && <ChevronEndIcon />}
                    </Flex>
                );
            })}
        </Flex>
    );
};

export default BreadcrumbFolders;

const NavItem = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    :not(.lastItem) {
        color: var(--Light-theme-Rest-Foreground-Brand-Foreground, #5b5fc7);
        /* 133.333% */
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: auto;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
        cursor: pointer;
    }
`;
